import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2vgr3yu7bj: FaireBrandEntity = {
  token: "b_2vgr3yu7bj",
  type: "brand",
  name: "Dabble & Dollop®",
  avatarUrl:
    "https://cdn.faire.com/fastly/b1ec09efe3c0519677468720ab311a7117e01d3a56f659ae2180c043d3d85cfc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/95af4277d864e77935e81c7d48147fcb394ba184084a3d8ce88a18a927a19634.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b1ec09efe3c0519677468720ab311a7117e01d3a56f659ae2180c043d3d85cfc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/95af4277d864e77935e81c7d48147fcb394ba184084a3d8ce88a18a927a19634.jpeg",
  location: "Long Beach, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 62,
  isTopShop: true,
  isInsider: true,
  description:
    "Dabble & Dollop® is a children’s bath and body brand creating better-for-you, sensory-rich bathing experiences for babies and kids. \n\nGuided by the philosophies “Less Ingredients. More Love.” for babies and “Less Ingredients. More Fun.” for toddlers and children, we prioritize ingredient minimalism, transparency, and naturally derived, fully disclosed fragrances. In 2023, Dabble & Dollop earned the Good Housekeeping Best of Baby Award. Founded by ingredient-industry veteran and mother of three Stephanie Leshney, we are family-owned and family-run. \n\nDabble & Dollop ships its products directly to you from our headquarters in Long Beach, California, and is powered by a small, dedicated team with deep expertise in natural ingredients. We have a singular focus on babies and kids—proudly standing apart from private equity-backed conglomerates and billion-dollar “Big Bubble” brands.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:09.119Z",
    importedBy: "entity-db-cli",
  },
};
